module.exports = __webpack_public_path__ + "static/eeca6e.jpg";